import { z } from 'zod';

export const CommonEntitySchema = z.object({
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type CommonEntityData = z.infer<typeof CommonEntitySchema>;
